import classNames from 'classnames';
import { SVGPropsIcon } from 'src/types';

export const Arrow = (props: SVGPropsIcon) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke={props.fill}
      onClick={props.onClick}
      className={props.className}
      style={props.style}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
    </svg>
  );
};

export const SidebarArrow = (props: SVGPropsIcon) => {
  return (
    <svg
      {...props}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5 12.0005H19"
        stroke="var(--arrow_sidebar)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 5.00049L19 12.0005L12 19.0005"
        stroke="var(--arrow_sidebar)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LoyaltyArrow = (props: SVGPropsIcon) => {
  return (
    <svg
      {...props}
      width="50"
      height="51"
      viewBox="0 0 50 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M32.7229 27.4714L22.3063 37.888C21.9 38.2942 21.3667 38.4984 20.8333 38.4984C20.3 38.4984 19.7666 38.2942 19.3604 37.888C18.5458 37.0734 18.5458 35.7567 19.3604 34.9422L28.3042 25.9984L19.3605 17.0547C18.5459 16.2401 18.5459 14.9234 19.3605 14.1089C20.175 13.2943 21.4917 13.2943 22.3063 14.1089L32.7229 24.5256C33.5375 25.3401 33.5375 26.6567 32.7229 27.4714Z"
        fill="var(--vp_loyalty_arrow)"
      />
    </svg>
  );
};

export const ArrowSingleGame = (props: SVGPropsIcon) => {
  return (
    <svg
      {...props}
      width="12"
      height="7"
      viewBox="0 0 12 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={props.onClick}
      className={classNames(props.className)}
      style={props.style}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.3447 6.4541C11.0335 6.7653 10.529 6.7653 10.2178 6.4541L6 2.23633L1.78223 6.4541C1.47103 6.7653 0.966473 6.7653 0.655274 6.4541C0.344075 6.1429 0.344075 5.63835 0.655275 5.32715L5.43652 0.545899C5.74772 0.2347 6.25228 0.2347 6.56348 0.545899L11.3447 5.32715C11.6559 5.63835 11.6559 6.1429 11.3447 6.4541Z"
        fill="var(--sgp_header_arrow)"
      />
    </svg>
  );
};

export const ArrowsShop = (props: SVGPropsIcon) => {
  return (
    <svg
      {...props}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g id="exchange 1" clipPath="url(#clip0_14092_80235)">
        <path
          id="Vector"
          d="M25.0879 18.9275V21.3408C25.0879 22.1073 25.241 22.7504 25.5431 23.2513C25.9599 23.9427 26.644 24.339 27.4207 24.339C28.1817 24.339 28.9379 23.9684 29.6681 23.2382L37.6391 15.2672C39.3892 13.5171 39.3892 10.6694 37.6391 8.91931L29.6681 0.948364C28.9379 0.217773 28.1817 -0.152466 27.4207 -0.152466C26.2594 -0.152466 25.0879 0.77478 25.0879 2.8457V5.03748C13.7713 5.70581 4.40288 14.3905 3.01054 25.761C2.93254 26.396 3.29362 27.0039 3.88872 27.2394C4.05717 27.306 4.23259 27.3383 4.4058 27.3383C4.84453 27.3383 5.27006 27.1328 5.54106 26.7626C9.27568 21.6598 15.272 18.6133 21.5811 18.6133C22.75 18.6133 23.9256 18.7188 25.0879 18.9275Z"
          fill="white"
          fillOpacity="0.5"
        />
        <path
          id="Vector_2"
          d="M44.0861 20.4553C43.491 20.2194 42.812 20.4157 42.4337 20.9324C38.6995 26.0348 32.7031 29.0814 26.3941 29.0814C25.2251 29.0814 24.0496 28.9759 22.8872 28.7671V26.3538C22.8872 24.2829 21.7153 23.3556 20.5545 23.3556C19.7935 23.3556 19.0372 23.7263 18.3067 24.4568L10.3357 32.4274C8.58595 34.1775 8.58595 37.0252 10.3361 38.7757L18.3067 46.7463C19.0372 47.4769 19.7935 47.8471 20.5545 47.8471C21.7153 47.8471 22.8872 46.9199 22.8872 44.8489V42.6572C34.2042 41.9888 43.5723 33.3041 44.9646 21.934C45.0426 21.2986 44.6815 20.6907 44.0861 20.4553Z"
          fill="white"
          fillOpacity="0.5"
        />
      </g>
      <defs>
        <clipPath id="clip0_14092_80235">
          <rect width="48" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
